//
//
//
//
//
//
//
//
//

import Item from "./Item.vue";
export default {
  name: "BlueTags",
  components: { Item },
  computed: {
    tags() {
      const recurse = (filters, groupName, isChildFilter = false) => {
        const tags = []
        filters.forEach((f) => {
          if (f.selected) {
            tags.push({ ...f, groupName, isChildFilter: Boolean(isChildFilter) });
          }
          if (f.filters && Array.isArray(f.filters) && f.filters.length > 0) {
            let _tags = recurse(f.filters, groupName, true);
            if (_tags.length) {
              tags.push(..._tags);
            }
          }
        });
        return tags;
      }
      return this.$store.getters.results.filters?.reduce((_tags, g) => {
        // If this group has a parent (is a child group), mark all its filters as child filters
        const isChildGroup = g.hasParent === true;
        const tags = recurse(g.filters, g.name, isChildGroup);
        _tags.push(...tags);
        return _tags;
      }, []) || [];
    },
  },
  methods: {
    clearAllTags() {
      this.$store.dispatch("removeAllTags");
    },
    removeTag(tag) {
      this.$store.dispatch("removeTagItem", tag);
    },
  },
};
